import { Box, SearchIcon } from '@iheartjane/reefer';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { useUserSearchQuery } from '@jane/bloom/hooks/useUserSearchQuery';

import styles from './searchFieldButton.module.css';

export const SearchFieldButton = () => {
  const { pinnedStore } = useRootLoaderData();
  const { showSearchSuggestions } = useUserSearchQuery();

  return (
    <button
      aria-label={`Search ${pinnedStore.name}`}
      className={styles['button']}
      onClick={() => showSearchSuggestions('overlay')}
      type="button"
    >
      <Box>
        <SearchIcon color="grays-black" />
      </Box>
      <span className={styles['label']}>Search {pinnedStore.name}</span>
    </button>
  );
};
